import SuccessRedsys from "@/views/public/success/redsys/SuccessRedsys.vue";

export default {
  path: "/success-redsys",
  name: "successRedsys",
  component: SuccessRedsys
};
